import { formatRelativeDate, translate } from '@/lib/i18n/runtime';
import type { DueInfo } from './thread-tracking';

export function chatActivityTime(iso?: string):string {
  return iso&&Number.isFinite(Date.parse(iso))?formatRelativeDate(iso):'';
}
export function trackedStatusCopy(status?:string|null):string {
  const key=status??'open';
  return ['open','in_progress','resolved'].includes(key)?translate('status.'+key,{},'teamchat'):key;
}
export function trackedDueCopy(iso:string|null|undefined,now=Date.now()):DueInfo|null {
  if(!iso||!Number.isFinite(Date.parse(iso)))return null;
  const diff=Date.parse(iso)-now;
  const key=diff<0?'overdue':diff>=86400000&&diff<172800000?'tomorrow':'future';
  return {label:translate('due.'+key,{time:formatRelativeDate(iso,undefined,now)},'teamchat'),tone:diff<0?'overdue':diff<86400000?'soon':'ok'};
}
